export const selectFeatureSwitches = state => state.environment.featureSwitches;

export const selectAppInfo = state => ({
    isHybridAppContextForAndroid:
        state.environment.isHybridAppContextForAndroid,
    isHybridAppContextForIos: state.environment.isHybridAppContextForIos,
    isHybridAppContext: state.environment.isHybridAppContext,
    isNativeAppContext: state.environment.isNativeAppContext,
    hybridAppVersion: state.environment.hybridAppVersion
});
